<template>
  <div>
    <section class="app-section"
      v-loading.fullscreen="isRequesting"
      element-loading-text="サーバーに問い合わせています">
      <header class="app-header flex justify-between items-center">
        <h2 class="app-h2">投稿一覧</h2>
        <el-button @click="dialogAddPostVisible = true">新規作成</el-button>
      </header>

      <template v-if="isInitialized">
        <el-table :data="posts" stripe style="width: 100%">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column label="アイキャッチ画像" width="150">
            <template slot-scope="scope">
              <div class="flex justify-center align-center">
                <template v-if="scope.row.featured_media !== 0">
                  <img @click="onSelectImage(scope.row, getFeaturedMedia(scope.row.featured_media))" :src="getFeaturedMedia(scope.row.featured_media).media_details.sizes.thumbnail.source_url" width="130" height="130">
                </template>
                <template v-else>
                  <el-button @click="onSelectImage(scope.row)" type="primary" icon="el-icon-picture"></el-button>
                </template>
                <!-- <input class="table-input" v-model="scope.row.featured_media" /> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column label="タイトル" width="300">
            <template slot-scope="scope">
              <div class="flex justify-center items-center">
                <input class="table-input" v-model="scope.row.title.rendered" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="スラッグ" width="300">
            <template slot-scope="scope">
              <input class="table-input" v-model="scope.row.slug" />
            </template>
          </el-table-column>
          <el-table-column label="状態" width="220">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.status" size="mini">
                <el-radio-button label="publish">公開</el-radio-button>
                <el-radio-button label="private">非公開</el-radio-button>
                <el-radio-button label="draft">下書き</el-radio-button>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="修正日" width="170">
            <template slot-scope="scope">
              <span>{{ formatDate(scope.row.modified) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="330">
            <template slot-scope="scope">
              <div class="flex items-center">
                <el-tooltip class="item" effect="dark" content="投稿を閲覧する" placement="top">
                  <el-button size="small" @click="window.open(scope.row.link)"><i class="fa fa-fw fa-external-link" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="投稿をプレビューする" placement="top">
                  <el-button size="small" @click="onPreview(scope.row)"><i class="fa fa-fw fa-desktop" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="投稿を更新する" placement="top">
                  <el-button size="small" @click="onUpdate(scope.row)"><i class="fa fa-fw fa-refresh" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="投稿を編集する" placement="top">
                  <el-button size="small" @click="onEdit(scope.row)"><i class="fa fa-fw fa-edit" aria-hidden="true"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="投稿を削除する" placement="top">
                  <el-button size="small" type="danger" @click="confirmBeforeDelete(scope.row)"><i class="fa fa-fw fa-trash" aria-hidden="true"></i></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>

    </section>

    <el-dialog width="90%" title="画像の選択" :visible.sync="dialogImageSelectVisible">
      <select-image v-model="selectedImage.image" @change="onUpdateImage"></select-image>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogImageSelectVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="onUpdateImage">選択</el-button>
      </span>
    </el-dialog>

    <el-dialog class="centering" width="90%" title="プレビュー" :visible.sync="previewDialogVisible">
      <iframe :class="['preview-iframe', previewSize]" :src="previewLink"></iframe>
      <span slot="footer" class="preview-footer flex column justify-center items-center row-s justify-between-s">
        <div class="preview-controller flex column justify-center items-center row-m">
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'smartphone'"><i class="fa fa-fw fa-mobile" aria-hidden="true"></i>Smartphone</el-button>
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'tablet'"><i class="fa fa-fw fa-tablet" aria-hidden="true"></i>Tablet</el-button>
          <el-button class="preview-controller-button m1" type="primary" @click="previewSize = 'desktop'"><i class="fa fa-fw fa-desktop" aria-hidden="true"></i>Desktop</el-button>
        </div>
        <el-button class="preview-controller-button" type="primary" @click="previewDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog width="280px" title="確認" :visible.sync="dialogVisible">
      <template v-if="deletingPost">
        <p>{{ deletingPost.title.rendered }}</p>
      </template>
      <p>この投稿を削除しますか？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">いいえ</el-button>
        <el-button type="primary" @click="deletePost">はい</el-button>
      </span>
    </el-dialog>

    <el-dialog width="50%" top="50px" title="投稿の新規作成" :visible.sync="dialogAddPostVisible">
      <el-form ref="newPost" :model="newPost" label-position="left" class="padding">
        <el-form-item label="タイトル" prop="title" :rules="[{required: true, message: 'タイトルは必ず入力してください'}]">
          <el-input class="width-100" type="text" v-model.trim="newPost.title" placeholder="（例）ホームページをリニューアルしました" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="スラッグ（投稿のURLパス）" prop="slug" :rules="[{required: true, message: 'スラッグは必ず入力してください'}]">
          <el-input class="width-100" type="text" v-model.trim="newPost.slug" placeholder="（例）renewal-homepage" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状態" label-width="90px">
          <el-radio-group v-model="newPost.status" size="mini">
            <el-radio-button label="publish">公開</el-radio-button>
            <el-radio-button label="private">非公開</el-radio-button>
            <el-radio-button label="draft">下書き</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-button @click="onSelectImageForNewPost()">アイキャッチ画像の選択</el-button>
        <div class="image-info flex column justify-between items-center">
          <template v-if="getFeaturedMedia(newPost.featured_media)">
            <img class="image-info-img" :src="getFeaturedMedia(newPost.featured_media).media_details.sizes['300x300'].source_url">
            <p class="image-info-size">画像のサイズ：{{ getFeaturedMedia(newPost.featured_media).media_details.sizes['300x300'].width }}x{{ getFeaturedMedia(newPost.featured_media).media_details.sizes['300x300'].height }}</p>
          </template>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddPostVisible = false">キャンセル</el-button>
        <el-button :disabled="!isFormFilled" type="primary" @click="onCreate(newPost)">作成</el-button>
      </span>
    </el-dialog>

    <el-dialog width="50%" :title="error.title" :visible.sync="dialogErrorVisible">
      <span>{{ error.message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogErrorVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import RouteBase from '@/components/mixins/RouteBase'
import SelectImage from '@/components/app/SelectImage'

const NEW_POST = {
  title: '',
  slug: '',
  date: new Date(),
  status: 'publish',
  featured_media: 0
}

export default {
  name: 'posts',
  mixins: [RouteBase],
  components: {
    'select-image': SelectImage
  },
  data: function () {
    return {
      window: window,
      dialogVisible: false,
      previewDialogVisible: false,
      dialogAddPostVisible: false,
      dialogImageSelectVisible: false,
      deletingPost: null,
      previewLink: null,
      previewSize: 'desktop',
      sort: {
        type: 'menu_order',
        order: 1
      },
      newPost: Object.assign({}, NEW_POST),
      selectedImage: {
        postId: null,
        image: {
          id: null,
          src: null,
          width: null,
          height: null
        }
      }
    }
  },
  computed: {
    isFormFilled: function () {
      return this.newPost.title !== '' && this.newPost.slug !== ''
    }
  },
  methods: {
    /**
     * 投稿をソート
     */
    sortPosts: function (type, order) {
      // if (this.sort.type === type) {
      //   this.sort.order *= -1
      // } else {
      //   this.sort.type = type
      //   this.sort.order = 1
      // }
      // if (type === 'title') {
      //   this.posts.sort((a, b) => a.title.rendered > b.title.rendered ? this.sort.order : -this.sort.order)
      // } else {
      //   this.posts.sort((a, b) => a[this.sort.type] > b[this.sort.type] ? this.sort.order : -this.sort.order)
      // }
    },
    /**
     * momentで日付をフォーマットして表示
     */
    formatDate: function (date) {
      return moment(date).format('YYYY年M月D日k時m分')
    },
    getFeaturedMedia: function (id) {
      return this.media.find(media => media.id === id)
    },
    onSelectImageForNewPost: function (id) {
      this.selectedImage.postId = 0
      const selected = this.media.find(image => image.id === id)
      if (selected) {
        this.selectedImage.image.id = selected.id
        this.selectedImage.image.src = selected.source_url
        this.selectedImage.image.width = selected.media_details.width
        this.selectedImage.image.height = selected.media_details.height
      }
      this.dialogImageSelectVisible = true
    },
    /**
     * 「画像の選択」ボタンをクリックした場合にselectedImageに対応するプロパティを入れる
     */
    onSelectImage: function (post, image) {
      this.selectedImage.postId = post.id
      this.selectedImage.image.id = image ? image.id : null
      this.selectedImage.image.src = image ? image.source_url : null
      this.selectedImage.image.width = image ? image.media_details.width : null
      this.selectedImage.image.height = image ? image.media_details.height : null
      this.dialogImageSelectVisible = true
    },
    /**
     * 画像選択のダイアログで選択ボタンをクリックした場合に、対応するプロパティに選んだ画像情報を入れる
     */
    onUpdateImage: function () {
      if (this.selectedImage.postId === 0) {
        this.newPost.featured_media = this.selectedImage.image.id
      } else {
        this.posts.find(post => post.id === this.selectedImage.postId).featured_media = this.selectedImage.image.id
      }

      this.selectedImage.postId = null
      this.selectedImage.image.id = null
      this.selectedImage.image.src = null
      this.selectedImage.image.width = null
      this.selectedImage.image.height = null

      this.dialogImageSelectVisible = false
    },
    /**
     * 投稿を新規作成
     */
    onCreate: async function (newPost) {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/posts/create', newPost)
      this.isRequesting = false
      if (response.id) {
        this.$notify({
          title: '作成完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })

        // this.newPost = Object.assign({}, NEW_POST)
      } else {
        this.$notify({
          title: '作成失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
      this.dialogAddPostVisible = false
    },
    /**
     * 投稿を更新
     */
    onUpdate: async function (post) {
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/posts/update', post)
      this.isRequesting = false
      if (response.id === post.id) {
        this.$notify({
          title: '更新完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '更新失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
    },
    /**
     * 投稿ページのコンポーネントを編集
     */
    onEdit: function (post) {
      this.$store.commit('wordpress/posts/select', post.id)
      this.$router.push({name: 'post', params: {id: post.id, post}})
    },
    /**
     * 投稿ページのページ内プレビュー
     */
    onPreview: function (post) {
      this.previewLink = post.link
      this.previewDialogVisible = true
    },
    /**
     * 投稿を削除する前に確認する
     */
    confirmBeforeDelete: async function (post) {
      this.dialogVisible = true
      this.deletingPost = post
    },
    /**
     * 投稿を削除する
     */
    deletePost: async function () {
      this.dialogVisible = false
      this.isRequesting = true
      let response = await this.$store.dispatch('wordpress/posts/delete', this.deletingPost.id)
      this.isRequesting = false
      if (response.id === this.deletingPost.id) {
        this.$notify({
          title: '削除完了',
          message: 'サーバーデータを更新しました',
          type: 'success',
          duration: 1500
        })
      } else {
        this.$notify({
          title: '削除失敗',
          message: 'サーバーデータを更新できませんでした',
          type: 'error',
          duration: 1500
        })
      }
      this.deletingPost = null
    }
  },
  created: async function () {
    if (process.env.NODE_ENV !== 'production') console.log('On Posts created...')

    this.isRequesting = true
    try { await this.requestMedia() } catch (error) { return false }
    try { await this.requestPosts() } catch (error) { return false }
    this.isRequesting = false
    this.isInitialized = true

    console.log(this.posts)
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';
.preview {
  &-footer {
    & .fa.fa-fw {
      margin-right: .25em;
    }
  }
  &-iframe {
    display: block;
    margin: auto;
    border: none;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 70vh;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    background-color: #fff;
    &.smartphone {
      width: 320px;
    }
    &.tablet {
      width: 768px;
    }
    &.desktop {
      width: 100%;
    }
  }
}

.table-input {
  display: block;
  padding: .25em .75em;
  border-width: 1px;
  border-color: $--color-primary;
  border-radius: 4px;
  width: 100%;
  min-height: 2.5em;
  outline: none;
  &:focus {
    border-style: solid;
    background-color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/routes/Posts.vue